export default {
  namespaced: true,
  state:{
    groups: [],
    unassigned: [],
    tasks: [],
    // Si el período admite anulación. Depende de que haya tareas y de que el plazo de
    // ajustes del administrador siga abierto: pasado ese día no hay nada que corregir.
    canVoid: false,
    adminCloseDay: null,
    plan: null,
    assignDialog: {
      modal: false,
      groupId: null,
      groupName: '',
      clientIds: []
    },
    groupDialog: {
      modal: false,
      id: null,
      name: '',
      active: true
    }
  },
  getters:{
    groups: state => state.groups,
    unassigned: state => state.unassigned,
    tasks: state => state.tasks,
    canVoid: state => state.canVoid,
    adminCloseDay: state => state.adminCloseDay,
    plan: state => state.plan,
    assignDialog: state => state.assignDialog,
    groupDialog: state => state.groupDialog
  },
  mutations:{
    SET_GROUPS(state, value){
      state.groups = value.groups;
      state.unassigned = value.unassigned;
    },
    SET_TASKS(state, value){
      state.tasks = value.tasks;
      state.canVoid = value.can_void;
      state.adminCloseDay = value.admin_close_day;
    },
    SET_PLAN(state, value){ state.plan = value; },
    SET_ASSIGN_DIALOG(state, value){
      state.assignDialog = Object.assign({}, state.assignDialog, value);
    },
    SET_GROUP_DIALOG(state, value){
      state.groupDialog = Object.assign({}, state.groupDialog, value);
    }
  },
  actions:{
    getGroups({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('stock/task-groups').then((response) => {
          commit('SET_GROUPS', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    storeGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('stock/task-groups', payload)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    updateGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('stock/task-groups/' + payload.id, payload)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    destroyGroup({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('stock/task-groups/' + id)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    assignClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('stock/task-groups/' + payload.id + '/clients', { client_ids: payload.client_ids })
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    getTasks({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('stock/tasks', { params: payload || {} }).then((response) => {
          commit('SET_TASKS', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getPlan({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('stock/tasks/preview', { params: payload }).then((response) => {
          commit('SET_PLAN', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    voidGeneration({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('stock/tasks/void', payload)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    generate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('stock/tasks/generate', payload)
          .then(response => resolve(response)).catch(error => reject(error));
      });
    },
    // Una tarea es UN PDF: la hoja de bodega en la primera página y una orden por conjunto
    // en las siguientes. El ZIP sólo queda para la descarga del período completo, donde hay
    // un PDF por ruta. `descargarArchivo` es común a las dos para no repetir el manejo del
    // blob y del error.
    downloadPdf({ dispatch }, task) {
      return dispatch('descargarArchivo', {
        url: 'stock/tasks/' + task.id + '/pdf',
        datos: {},
        tipo: 'application/pdf',
        porDefecto: 'Tarea.pdf'
      });
    },
    downloadAll({ dispatch }, payload) {
      return dispatch('descargarArchivo', {
        url: 'stock/tasks/download-all',
        datos: payload,
        tipo: 'application/zip',
        porDefecto: 'Tareas.zip'
      });
    },
    // POST y no GET: la descarga registra en el servidor que los documentos se produjeron,
    // así que modifica estado.
    descargarArchivo(_, { url, datos, tipo, porDefecto }) {
      return new Promise((resolve, reject) => {
        axios({ url, method: 'POST', data: datos, responseType: 'blob' })
          .then(response => {
            const objeto = window.URL.createObjectURL(new Blob([response.data], { type: tipo }));
            const link = document.createElement('a');
            link.href = objeto;

            // El nombre viene del backend; si el navegador no expone la cabecera se usa uno
            // genérico para que la descarga no quede sin nombre.
            const disposition = response.headers['content-disposition'];
            let filename = porDefecto;
            if (disposition) {
              const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (match && match[1]) filename = match[1].replace(/['"]/g, '');
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(objeto);
            resolve(response);
          })
          .catch(async error => {
            // El error llega como Blob por el responseType; se convierte a JSON para que
            // handleError pueda mostrar el mensaje del backend.
            if (error.response && error.response.data instanceof Blob) {
              try {
                const texto = await error.response.data.text();
                error.response.data = JSON.parse(texto);
              } catch (e) {
                console.error('Error no es JSON válido');
              }
            }
            reject(error);
          });
      });
    }
  }
}
